import { Box, Flex, Spacer } from '@chakra-ui/react';
import VCheckbox from '@voly/ui-components/src/v2/VCheckbox';
import VStack from '@voly/ui-components/src/v2/VStack.jsx';
import VText from '@voly/ui-components/src/v2/VText.jsx';
import VTooltip from '@voly/ui-components/src/v2/VTooltip';
import { translate } from 'src/app/project/features/translate/translate';
import { TCustomField } from 'src/app/project/modules/custom-fields/custom-fields.model';
import { getCustomFieldTypeLabel } from '../../utils/customFieldType';
import CustomFieldTypeIcon from './custom-fields/CustomFieldTypeIcon';

const MAX_LABEL_LENGTH_WITHOUT_TOOLTIP = 55;

export type TFieldExclusionReason = 'NAME_TAKEN' | 'VOLY_INTEGRATION';

const EXCLUSION_MESSAGE_KEY: Record<TFieldExclusionReason, string> = {
  NAME_TAKEN: 'custom_field_name_already_exists_on_site',
  VOLY_INTEGRATION: 'import_custom_fields_voly_field_excluded',
};

export interface ImportCustomFieldRowProps {
  field: TCustomField;
  selected: boolean;
  exclusionReason?: TFieldExclusionReason;
  onToggle: (fieldId: string) => void;
}

const ImportCustomFieldRow = ({
  field,
  selected,
  exclusionReason,
  onToggle,
}: ImportCustomFieldRowProps) => {
  const toggle = () => {
    onToggle(field.id);
  };

  return (
    <Flex
      align="center"
      gap={2}
      p={4}
      data-testid="import-custom-field-row"
      justifyContent="space-between"
      _notLast={{ borderBottomWidth: '1px' }}
      bg={selected ? 'primary.subtle' : 'transparent'}
    >
      <VCheckbox checked={selected} disabled={Boolean(exclusionReason)} onCheckedChange={toggle}>
        <VStack maxWidth={'350px'}>
          <VTooltip
            content={field.label}
            contentProps={undefined}
            disabled={field.label.length <= MAX_LABEL_LENGTH_WITHOUT_TOOLTIP}
          >
            <Box>
              <VText truncate>{field.label}</VText>
            </Box>
          </VTooltip>

          {exclusionReason && (
            <VText color="fg.muted" textStyle="sm">
              {translate(EXCLUSION_MESSAGE_KEY[exclusionReason])}
            </VText>
          )}
        </VStack>
      </VCheckbox>

      <Spacer />

      <Flex w={40} align="center" gap={2} color="fg.muted">
        <CustomFieldTypeIcon field={field} size="md" />
        <span>{getCustomFieldTypeLabel(field)}</span>
      </Flex>
    </Flex>
  );
};

export default ImportCustomFieldRow;
